import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Feature } from '../../lib/supabase';
import '../../styles/utilities/layout.css';

interface FeatureCardProps {
  feature: Feature;
  className?: string;
  fromCategory?: boolean; // New prop to indicate if card is displayed in a category page
}

const FeatureCard: React.FC<FeatureCardProps> = ({ feature, className = '', fromCategory = false }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (feature.route) {
      navigate(feature.route, {
        state: { fromCategory: fromCategory }
      });
    }
  };

  const handleCategoryClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering the card click
    if (feature.category) {
      navigate(`/features/category/${feature.category}`);
    }
  };

  const isClickable = !!feature.route;

  return (
    <div 
      className={`card feature-card ${className} ${isClickable ? 'clickable' : ''}`}
      onClick={isClickable ? handleClick : undefined}
      style={{ 
        cursor: isClickable ? 'pointer' : 'default',
        transition: 'all 0.3s ease'
      }}
    >
      {feature.image_url && (
        <div className="card-image" style={{
          width: '100%',
          height: '200px',
          overflow: 'hidden',
          borderRadius: '8px 8px 0 0'
        }}>
          <img 
            src={feature.image_url} 
            alt={feature.title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </div>
      )}
      <div className="card-content">
        <h3 className="card-title">{feature.title}</h3>
        {feature.description && (
          <p className="card-description">{feature.description}</p>
        )}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px' }}>
          {feature.category && (
            <span 
              className="post-category-badge" 
              onClick={handleCategoryClick}
              style={{
                cursor: 'pointer'
              }}
            >
              {feature.category}
            </span>
          )}
          {isClickable && (
            <div className="card-arrow">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path 
                  d="M6 4L10 8L6 12" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;